import Vue from "vue";
import Vuex from "vuex";
import VueJwtDecode from 'vue-jwt-decode'
import router from "./router/";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        jwt: localStorage.getItem('t'),
        refresh: localStorage.getItem('r'),
        encabezado: null,
        asignacion: [],
        periodo_abierto: null,
        endpoints: {
            //Produccion
            obtainJWT: 'https://evaluacion.cusam.edu.gt/api/token/',
            refreshJWT: 'https://evaluacion.cusam.edu.gt/api/token/refresh/',
            baseUrl: 'https://evaluacion.cusam.edu.gt/api/'
                //Development
                //obtainJWT: 'http://localhost:8000/api/token/',
                //refreshJWT: 'http://localhost:8000/api/token/refresh/',
                //baseUrl: 'http://localhost:8000/api/'
        },
        pagination: {
            descending: true,
            page: 1,
            rowsPerPage: 25,
            totalItems: 0,
            rowsPerPageItems: [25],
            nextPage: "",
            previousPage: ""
        },

    },
    getters: {
        token: state => state.jwt,
        refresh: state => state.refresh,
        asignacion: state => state.asignacion,
        periodo_abierto: state => state.periodo_abierto,
        encabezado: state => state.encabezado,
    },
    mutations: {
        updateToken(state, newToken) {
            state.jwt = newToken;
        },
        removeToken(state) {
            localStorage.removeItem('t');
            localStorage.removeItem('r');
            localStorage.removeItem('u');
            state.jwt = null;
            state.refresh = null;
        },
        updateAsignacionList(state, newList) {
            state.asignacion = newList;
        },
        updateEncabezado(state, newValue) {
            state.encabezado = newValue;
        },
        updatePeriodo(state, newValue) {
            state.periodo_abierto = newValue;
        },
        setPagination(state, { total, next, previous }) {
            state.pagination.totalItems = total;
            state.pagination.nextPage = next;
            state.pagination.previousPage = previous;
        },

    },
    actions: {
        obtainToken(state, data) {
            const payload = {
                username: data.username,
                password: data.password
            }
            Vue.axios.post(this.state.endpoints.obtainJWT, payload)
                .then((response) => {
                    let token = response.data.token;
                    localStorage.setItem('t', token);
                    let Tokendata = VueJwtDecode.decode(token);
                    localStorage.setItem('u', Tokendata.username);
                    this.commit('updateToken', token);
                })
                .catch((error) => {
                    this.commit('removeToken');
                })
        },
        refreshToken() {
            const payload = {
                token: this.state.refresh
            }
            Vue.axios.post(this.state.endpoints.refreshJWT, payload)
                .then((response) => {
                    let token = response.data.token;
                    this.commit('updateToken', token)
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        //METODOS ASIGNACIONES ---------------------------------------------------->

        getAsignacion() {
            Vue.axios.get(this.state.endpoints.baseUrl + "asignacion/", {
                    params: {
                        carne: localStorage.getItem('u'),
                    }
                })
                .then(response => {

                    let periodo = response.data.periodo_abierto;
                    let results = response.data.results;
                    let total = response.data.count;
                    let next = response.data.next;
                    let previous = response.data.previous;
                    let encabezado = response.data;
                    this.commit('updatePeriodo', periodo);
                    this.commit('setPagination', { total, next, previous });
                    this.commit('updateEncabezado', encabezado);
                    this.commit('updateAsignacionList', results);

                })
                .catch(error => {
                    if (error.request.status === 401) {
                        this.commit('removeToken');
                        router.push("/login");
                    }
                });
        },

        // FIN METODOS DE ASIGANACION  ----------------------------------------------->
    }
});